module.exports = __webpack_public_path__ + "img/md.486ceb6b.png";